import React from 'react';
import BusComponent from './BusComponent';
import AppConfig from '../appConfig';

class ReportLimitsPopup extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            reportLimits: undefined,
        };
    }

    componentDidMount() {
        this.bindGluBusEvents({
            REPORT_LIMITS_GET_SUCCESS: this.onReportLimits,
        });
        this.emit('REPORT_LIMITS_GET_REQUEST');
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onReportLimits(reportLimits) {
        this.setState({
            reportLimits,
        });
    }

    render() {
        const { reportLimits } = this.state;
        if (!reportLimits) return null;

        const usedAllReports = reportLimits.remaining <= 0;

        const endDate = new Date(reportLimits.endDate).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });

        const supportEmail = AppConfig.constants.supportEmail;

        const copyEmailButton = (
            <button className="report-usage-modal--copy-email-btn">
                <i
                    className="material-symbols report-usage-modal--copy-email"
                    onClick={() => {
                        navigator.clipboard.writeText(supportEmail);
                    }}
                    title="Copy email to clipboard"
                >
                    content_copy
                </i>
            </button>
        );

        const unusedDialogContent = (
            <div className="body-1 report-usage-modal--content">
                <span>
                    You have{' '}
                    <strong>
                        {reportLimits.remaining} of {reportLimits.reportLimit}
                    </strong>{' '}
                    data exports remaining in your {reportLimits.subscriptionPlan} subscription.
                </span>
                <span>
                    Your limit resets on <strong>{endDate}</strong>.
                </span>
                <span>
                    If you expect to exceed the limit, you can request an upgrade at {supportEmail}{' '}
                    {copyEmailButton}
                </span>
            </div>
        );

        const usedAllDialogContent = (
            <div className="body-1 report-usage-modal--content">
                <span>
                    You've used all{' '}
                    <strong>
                        {reportLimits.reportLimit} of {reportLimits.reportLimit}
                    </strong>{' '}
                    data exports in your {reportLimits.subscriptionPlan} plan.
                </span>
                <span>
                    Your limit will reset on <strong>{endDate}</strong>.
                </span>
                <span>
                    If you need extra data exports before then, just reach out to {supportEmail}{' '}
                    {copyEmailButton}
                </span>
            </div>
        );

        return usedAllReports ? usedAllDialogContent : unusedDialogContent;
    }
}

export default ReportLimitsPopup;
